var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.75V14.625C12.25 15.1223 12.0525 15.5992 11.7008 15.9508C11.3492 16.3025 10.8723 16.5 10.375 16.5H2.875C2.37772 16.5 1.90081 16.3025 1.54917 15.9508C1.19754 15.5992 1 15.1223 1 14.625V3.375C1 2.87772 1.19754 2.40081 1.54917 2.04917C1.90081 1.69754 2.37772 1.5 2.875 1.5H10C11.0355 1.5 12.25 2.33953 12.25 3.375V5.25M15.25 12.75L19 9L15.25 5.25M6.25 9H18.25",
    stroke: "url(#paint0_linear_1690_19876)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1690_19876",
    x1: 10,
    y1: 1.5,
    x2: 10,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSm);
export default __webpack_public_path__ + "static/media/logoutSM.25d19fd9772135a750c270121a6fea6f.svg";
export { ForwardRef as ReactComponent };